(function () {
    "use strict";

    angular.module("app").controller("SearchAssistanceInListController", SearchAssistanceInListController);

    SearchAssistanceInListController.$inject = ["controllerDecorator", "securityCheck",];
    function SearchAssistanceInListController(controllerDecorator, securityCheck) {
        const vm = this;
        controllerDecorator.Decorate(vm, []);

        activate();

        function activate() {
            vm.Items = [];
            securityCheck.ForwardedLists(
                null,
                r => vm.Items = r.data,
                vm.ShowError,
                () => vm.SetLoadingState(false)
            );
        }
    }
})();